const StorageMoneyBillComponent = () => import('@/views/WareHouse/MoneyBill/StorageMoneyBillView')

export default [
    {
        path:'/StorageMoney',
        name:'StorageMoneyBillComponent',
        component:StorageMoneyBillComponent
    }
]